import { useNavigate } from 'react-router-dom';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          {/* Back Button */}
          <div className="mb-8">
            <button 
              onClick={() => navigate('/')}
              className="inline-flex items-center hover:opacity-80 transition-colors cursor-pointer group"
              style={{ color: '#B80E10' }}
            >
              <i className="ri-arrow-left-line text-xl mr-2 group-hover:-translate-x-1 transition-transform"></i>
              <span className="font-medium">Zurück zur Hauptseite</span>
            </button>
          </div>

          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">Datenschutzerklärung der handgepackt eGbR</h1>
            <div className="w-24 h-1 mx-auto" style={{ backgroundColor: '#B80E10' }}></div>
          </div>

          {/* Content */}
          <div className="prose prose-lg max-w-none">
            <div className="space-y-8">
              
              {/* Section 1 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>1</span>
                  Diese Datenschutz-Information gilt für die Datenverarbeitung durch:
                </h3>
                <div className="mt-6">
                  <p className="text-gray-800 leading-relaxed">
                    <strong>handgepackt eGbR</strong><br />
                    Römerstr. 1<br />
                    53424 Remagen<br />
                    Deutschland<br /><br />
                    E-Mail: hallo@handgepackt.de<br />
                    Website: www.handgepackt.de
                  </p>
                </div>
              </section>

              {/* Section 2 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>2</span>
                  Erhebung und Speicherung personenbezogener Daten sowie Art und Zweck von deren Verwendung
                </h3>
                <div className="space-y-6">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-3">a) Beim Besuch der Website</h4>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch 
                      Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sog. Logfile 
                      gespeichert. Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                      <li>IP-Adresse des anfragenden Rechners</li>
                      <li>Datum und Uhrzeit des Zugriffs</li>
                      <li>Name und URL der abgerufenen Datei</li>
                      <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                      <li>verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers</li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      Die genannten Daten werden durch uns zu folgenden Zwecken verarbeitet:
                    </p>
                    <ul className="list-disc list-inside text-gray-700 space-y-2 mb-4">
                      <li>Gewährleistung eines reibungslosen Verbindungsaufbaus der Website</li>
                      <li>Gewährleistung einer komfortablen Nutzung unserer Website</li>
                      <li>Auswertung der Systemsicherheit und -stabilität sowie</li>
                      <li>zu weiteren administrativen Zwecken</li>
                    </ul>
                    <p className="text-gray-700 leading-relaxed">
                      Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Unser berechtigtes Interesse folgt 
                      aus oben aufgelisteten Zwecken zur Datenerhebung. In keinem Fall verwenden wir die erhobenen Daten zu dem Zweck, 
                      Rückschlüsse auf Ihre Person zu ziehen.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-3">b) Bei Anmeldung für unseren Newsletter</h4>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      Sofern Sie nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrücklich eingewilligt haben, verwenden wir Ihre E-Mail-Adresse dafür, 
                      Ihnen regelmäßig unseren Newsletter zu übersenden. Für den Empfang des Newsletters ist die Angabe einer E-Mail-Adresse ausreichend.
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                      Die Abmeldung ist jederzeit möglich, zum Beispiel über einen Link am Ende eines jeden Newsletters. Alternativ können Sie 
                      Ihren Abmeldewunsch gerne auch jederzeit an info@handgepackt.de per E-Mail senden.
                    </p>
                  </div>

                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-3">c) Bei Nutzung unseres Kontaktformulars</h4>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      Bei Fragen jeglicher Art bieten wir Ihnen die Möglichkeit, mit uns über ein auf der Website bereitgestelltes Formular 
                      Kontakt aufzunehmen. Dabei ist die Angabe einer gültigen E-Mail-Adresse erforderlich, damit wir wissen, von wem die 
                      Anfrage stammt und um diese beantworten zu können. Weitere Angaben können freiwillig getätigt werden.
                    </p>
                    <p className="text-gray-700 leading-relaxed mb-4">
                      Die Datenverarbeitung zum Zwecke der Kontaktaufnahme mit uns erfolgt nach Art. 6 Abs. 1 S. 1 lit. a DSGVO auf Grundlage 
                      Ihrer freiwillig erteilten Einwilligung.
                    </p>
                    <p className="text-gray-700 leading-relaxed">
                      Die für die Benutzung des Kontaktformulars von uns erhobenen personenbezogenen Daten werden nach Erledigung der 
                      von Ihnen gestellten Anfrage automatisch gelöscht.
                    </p>
                  </div>
                </div>
              </section>

              {/* Section 3 */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>3</span>
                  Weitergabe von Daten
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Eine Übermittlung Ihrer persönlichen Daten an Dritte zu anderen als den im Folgenden aufgeführten Zwecken findet nicht statt.
                </p>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Wir geben Ihre persönlichen Daten nur an Dritte weiter, wenn:
                </p>
                <ul className="list-disc list-inside text-gray-700 space-y-2">
                  <li>Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrückliche Einwilligung dazu erteilt haben</li>
                  <li>die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist und kein Grund zur Annahme besteht, dass Sie ein überwiegendes schutzwürdiges Interesse an der Nichtweitergabe Ihrer Daten haben</li>
                  <li>für den Fall, dass für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche Verpflichtung besteht, sowie</li>
                  <li>dies gesetzlich zulässig und nach Art. 6 Abs. 1 S. 1 lit. b DSGVO für die Abwicklung von Vertragsverhältnissen mit Ihnen erforderlich ist</li>
                </ul>
              </section>

              {/* Section 4 - Betroffenenrechte (renumbered from 5) */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>4</span>
                  Betroffenenrechte
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">Sie haben das Recht:</p>
                <ul className="list-disc list-inside text-gray-700 space-y-3">
                  <li>gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen</li>
                  <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
                  <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen</li>
                  <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen</li>
                  <li>gemäß Art. 20 DSGVO Ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten</li>
                  <li>gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen</li>
                  <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren</li>
                </ul>
              </section>

              {/* Section 5 - Widerspruchsrecht (renumbered from 6) */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>5</span>
                  Widerspruchsrecht
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß Art. 6 Abs. 1 S. 1 lit. f DSGVO verarbeitet 
                  werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten einzulegen.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Möchten Sie von Ihrem Widerrufs- oder Widerspruchsrecht Gebrauch machen, genügt eine E-Mail an{' '}
                  <a href="mailto:info@handgepackt.de" className="hover:opacity-80 underline" style={{ color: '#B80E10' }}>
                    info@handgepackt.de
                  </a>
                </p>
              </section>

              {/* Section 6 - Datensicherheit (renumbered from 7) */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>6</span>
                  Datensicherheit
                </h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Wir verwenden innerhalb des Website-Besuchs das verbreitete SSL-Verfahren (Secure Socket Layer) in Verbindung mit der 
                  jeweils höchsten Verschlüsselungsstufe, die von Ihrem Browser unterstützt wird. In der Regel handelt es sich dabei um 
                  eine 256 Bit Verschlüsselung.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Wir bedienen uns im Übrigen geeigneter technischer und organisatorischer Sicherheitsmaßnahmen, um Ihre Daten gegen 
                  zufällige oder vorsätzliche Manipulationen, teilweisen oder vollständigen Verlust, Zerstörung oder gegen den unbefugten 
                  Zugriff Dritter zu schützen.
                </p>
              </section>

              {/* Section 7 - Aktualität (renumbered from 8) */}
              <section>
                <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                  <span className="text-white rounded-full w-8 h-8 flex items-center justify-center text-sm font-bold mr-3 flex-shrink-0" style={{ backgroundColor: '#B80E10' }}>7</span>
                  Aktualität und Änderung dieser Datenschutzerklärung
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Dezember 2024. Durch die Weiterentwicklung unserer 
                  Website und Angebote darüber oder aufgrund geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es 
                  notwendig werden, diese Datenschutzerklärung zu ändern.
                </p>
              </section>
            </div>

            {/* Contact Box */}
            <div className="mt-12 p-6 rounded-lg" style={{ backgroundColor: '#FEF2F2', borderColor: '#B80E10', borderWidth: '1px' }}>
              <div className="flex items-center mb-4">
                <i className="ri-information-line text-xl mr-3" style={{ color: '#B80E10' }}></i>
                <h4 className="text-lg font-semibold text-gray-900">Kontakt bei Datenschutzfragen</h4>
              </div>
              <p className="text-gray-700">
                Bei Fragen zum Datenschutz oder zur Ausübung Ihrer Rechte können Sie sich jederzeit an uns wenden:
              </p>
              <div className="mt-3">
                <p className="text-gray-800 font-medium">
                  E-Mail:{' '}
                  <a href="mailto:hallo@handgepackt.de" className="hover:opacity-80 underline" style={{ color: '#B80E10' }}>
                    hallo@handgepackt.de
                  </a>
                </p>
                <p className="text-gray-800">Adresse: handgepackt eGbR, Römerstr. 1, 53424 Remagen</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
